import { DashboardYearFilter } from '../components/DashboardYearFilter';
import { useGradeLevelData } from '../contexts';

export const GradeLevelFilterControls = () => {
    const { filter, updateFilter, activeSchoolYear } = useGradeLevelData();
    return <DashboardYearFilter idPrefix="grade-level" years={filter.schoolYears} activeSchoolYear={activeSchoolYear}
        onApply={schoolYears => updateFilter({ schoolYears })} />;
};
